/* eslint-disable import/prefer-default-export */
export const GET_PREFERENCE = 'GET_PREFERENCE';
